<div class="detail-page-action-bar flex-action-bar space-between">
    <div class="load-area">
        <button
            type="button"
            (click)="applyFilter()"
            class="btn btn-cerrix"
            [disabled]="!selectedBusinessDimensionId"
        >
            <i class="fas fa-link"></i>
            <span class="d-none d-lg-inline">{{ 'processEditor.loadProcess' | transloco }}</span>
            @if (!selectedBusinessDimensionId) {
                <i
                    class="far fa-question-circle ms-2"
                    [matTooltip]="'processEditor.pleaseSelectConfiguration' | transloco"
                ></i>
            }
        </button>
    </div>

    <div class="filtering-area">
        <div class="form-group smallfont">
            <label><b>{{ 'processEditor.organizationLabel' | transloco }}</b></label>
            <cerrix-select-tree
                [placeholder]="'processEditor.noSelectionMade' | transloco"
                [getDataMethod]="orgRequest"
                [(value)]="selectedOrganizationId"
                [multiselect]="false"
                (onChangeSingleId)="reloadBusinessData()"
            >
            </cerrix-select-tree>
        </div>

        <div class="form-group smallfont">
            <label for="businessDimenionTree">
                <b>{{ 'processEditor.businessDimensionLabel' | transloco }}</b>
            </label>
            <cerrix-select-tree
                [placeholder]="'processEditor.requiredPlaceholder' | transloco"
                [getDataMethod]="bdRequest"
                [(value)]="selectedBusinessDimensionId"
                [multiselect]="false"
            >
            </cerrix-select-tree>
        </div>
    </div>
</div>
